import React from "react";
import ComponenteConItemsForm from "./ComponenteConItemsForm";

export default function MaterialesElectricosForm() {
  return (
    <ComponenteConItemsForm
      titulo="Materiales Eléctricos"
      tipo="materialesElectricos"
    />
  );
}
